module.exports = __webpack_public_path__ + "img/screen-manual-6.d4614bbc.png";